<template>
  <section>
    <div class="row">
      <div class="col-md-12">
        <h4>Select an Occupation Group:</h4>
      </div>
      <div class="col-md-12">
        <select data-live-search="true" v-model="selected">
          <option v-for="option in options" :key="option">{{option}}</option>
        </select>
      </div>
    </div>
  </section>
</template>

<script>
import * as d3 from "d3";
import * as $ from "jquery";
import "bootstrap-select";
import "bootstrap-select/dist/css/bootstrap-select.css";

export default {
  data() {
    return {
      selected: ""
    };
  },
  props: {
    jobs: {
      type: Array
    }
  },
  computed: {
    options() {
      var unique = [...new Set(this.jobs.map(item => item.Occupation))];
      return unique.sort(d3.ascending);
    }
  },
  methods: {
    createTip(e, { currentTarget }) {
      this.tip(currentTarget)
    },
    updateTip({currentTarget}){
      this.tip($(currentTarget).parent().parent())
    },
    tip (target){
    var visible = [].slice.call($(target).find("li"));
      visible.forEach(d => {
        if ($(target).width() < $(d).find("span").width() + 60) {
          $(d).attr({ "data-toggle": "tooltip", title: d.textContent });
          $(d).tooltip();
        }
      });
    }
  },
  watch: {
    selected() {
      this.$emit("changejob", this.selected);
    }
  },
  mounted() {
    this.selected = "Architecture and Engineering";
    $("select").selectpicker("val", "Architecture and Engineering");
        $("select").on("shown.bs.select", this.createTip);
        $("div.inner").on("scroll", this.updateTip);
        $("select").on("changed.bs.select", ()=> { $('li').tooltip('dispose')});
  }
};
</script>

<style lang="scss">
.bootstrap-select:not([class*="col-"]):not([class*="form-control"]):not(.input-group-btn) {
  width: 100%;
  position: relative;
  ul.dropdown-menu {
    @media screen and (min-width: 768px) {
      width: 225px !important;
    }
    @media screen and (max-width: 768px) {
      width: calc(100vw - 160px) !important;
    }
    li {
      display: block;
      span {
        max-width: calc(100% + 10px);
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
    li:before {
    content: none;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Select.vue